import { formatTimeString } from '~libs/dayjs';

import { faEdit } from '~components/icon';
import { Column, Row } from '~components/table-view-v3';
import { linkCellRender } from '~components/table-view-v3/columnRenderers';
import { getEncryptedColumnProps } from '~libs/encryptionSettings';
import { showCompany } from '~appointments/lib/show';

export const getCommonColumns = (onOpen: (row: Row) => void): Column[] => [
  {
    id: 'reference_number',
    header: 'Reference Number',
    type: 'text',
    renderReadOnly: linkCellRender(onOpen, faEdit),
  },
  {
    id: 'client.full_name',
    header: 'Client',
    type: 'text',
    deriveValue: (row) => row.client?.full_name ?? '',
    ...getEncryptedColumnProps(),
  },
  {
    id: 'date',
    header: 'Date',
    type: 'date',
  },
  {
    id: 'start_time',
    header: 'Start Time',
    type: 'text',
    deriveValue: ({ start_time }) => formatTimeString(start_time),
  },
  {
    id: 'end_time',
    header: 'End Time',
    type: 'text',
    deriveValue: ({ end_time }) => formatTimeString(end_time),
  },
  {
    id: 'status.name',
    header: 'Status',
    type: 'text',
    deriveValue: (row) => row.status?.name ?? '',
  },
  {
    id: 'company.name',
    header: 'Company',
    type: 'text',
    deriveValue: (row) => row.company?.name ?? '',
    showColumn: () => showCompany() as boolean,
  },
];

export const getAllColumns = (onOpen: (row: Row) => void): Column[] => [
  ...getCommonColumns(onOpen),
  {
    id: 'user.full_name',
    header: 'Care Worker',
    type: 'text',
    deriveValue: (row) => row.user?.full_name ?? '',
  },
  {
    id: 'client.referrer_name',
    header: 'Referrer',
    type: 'text',
    deriveValue: (row) => row.client?.referrer_name ?? '',
  },
  {
    id: 'package_fixed.name',
    header: 'Package',
    type: 'text',
    deriveValue: (row) => row.package_fixed?.name ?? '',
  },
  {
    id: 'service_type.name',
    header: 'Service Type',
    type: 'text',
    deriveValue: ({ service_type }) =>
      service_type !== undefined ? `${service_type.name}${service_type.deleted ? ' - DELETED' : ''}` : '',
  },
];

export default getCommonColumns;
